import { render, staticRenderFns } from "./select-reward-popup.vue?vue&type=template&id=5df5f835&scoped=true&lang=pug&"
import script from "./select-reward-popup.vue?vue&type=script&lang=js&"
export * from "./select-reward-popup.vue?vue&type=script&lang=js&"
import style0 from "./select-reward-popup.vue?vue&type=style&index=0&id=5df5f835&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5f835",
  null
  
)

export default component.exports